import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboarding from "@/pages/Onboarding";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Settings from "@/pages/Settings";
import Unsubscribe from "@/pages/Unsubscribe";
import AdminHub from "@/pages/admin/AdminHub";
import AdminData from "@/pages/admin/AdminData";
import AdminBackoffice from "@/pages/admin/AdminBackoffice";
import AdminTest from "@/pages/admin/AdminTest";
import AdminFeedback from "@/pages/admin/AdminFeedback";
import Page from "@/pages/Page";
import MediaPage from "@/pages/MediaPage";
import { Toaster } from "@/components/ui/sonner";
import { CookieBanner } from "@/components/CookieBanner";
import { HelpWidget } from "@/components/HelpWidget";
import { ThemeProvider } from "@/context/ThemeContext";
import { useSeo } from "@/lib/seo";

function AppEntry() {
  const { user } = useAuth();
  if (user && !user.onboarded) return <Onboarding />;
  return <Home />;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user, loading } = useAuth();
  useSeo({ noindex: true });
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/forgot-password" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/admin" element={<AdminOnly><AdminHub /></AdminOnly>} />
            <Route path="/admin/datos" element={<AdminOnly><AdminData /></AdminOnly>} />
            <Route path="/admin/backoffice" element={<AdminOnly><AdminBackoffice /></AdminOnly>} />
            <Route path="/admin/test" element={<AdminOnly><AdminTest /></AdminOnly>} />
            <Route path="/admin/feedback" element={<AdminOnly><AdminFeedback /></AdminOnly>} />
            <Route path="/quienes-somos" element={<Page slug="quienes-somos" />} />
            <Route path="/compromiso-calidad" element={<Page slug="compromiso-calidad" />} />
            <Route path="/politica-cookies" element={<Page slug="politica-cookies" />} />
            <Route path="/medios/:slug" element={<MediaPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppEntry />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ajustes"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </BrowserRouter>
          <Toaster position="top-right" />
          <CookieBanner />
          <HelpWidget />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
